module.exports = __webpack_public_path__ + "img/palveluhakemus_tunnistaudu.cae8c31c.svg";